export interface Bonus {
  index: string
  title: string
  body: string
  value: string
  image: string
}

export const bonuses: Bonus[] = [
  {
    index: '01',
    title: 'Make Your Own Flower Press',
    body: 'Exact measurements, a short hardware-store list and the right layer order so the pressure stays even. The same press you would pay for, built by you, with room for several flowers at once.',
    value: 'Value $19',
    image:
      'https://cdn.magicpatterns.com/uploads/tba6hMQkL7UbM2wrkCFjkq/FLOWER_PRESS.png',
  },
  {
    index: '02',
    title: 'Seasonal Flower Calendar',
    body: 'What to gather in spring, summer, fall and winter, plus the best time of day to cut each one. So your material is ready before gifting season, instead of hunting for blooms once they are gone.',
    value: 'Value $14',
    image:
      'https://cdn.magicpatterns.com/uploads/gL22uYZQZhKB16u4ZUa5Ku/SEASONAL_CALENDAR.png',
  },
  {
    index: '03',
    title: 'The Meaning of Flowers Guide',
    body: 'Over 100 flowers and plants with their symbolism, so your gifts and cards actually say something. A rose, a sprig of lavender and a pansy do not mean the same thing, and the person receiving it feels the difference.',
    value: 'Value $17',
    image:
      'https://cdn.magicpatterns.com/uploads/2FpBawrGfm4X37PazBtMBJ/MEANING_OF_FLOWERS.png',
  },
  {
    index: '04',
    title: 'Printable Herbarium Record Kit',
    body: 'Botanical archive cards ready to print and fill in: species, date, place, method used and notes. You will know exactly what worked, and you can repeat it any time you want.',
    value: 'Value $12',
    image:
      'https://cdn.magicpatterns.com/uploads/kKEE5qy1my6iYGJUcZ2eg5/HERBARIUM_RECORD.png',
  },
]

export const bonusTotalValue = '$62'
